module.exports = __webpack_public_path__ + "img/Infografis_ID_21.fc509d34.jpg";